import __base_store from '@/store/__base_store'

/**
 * Store de descuentos de proveedor (modelo `provider_discount`) construido desde el factory común.
 */
export default __base_store({
	state: {
		model_name: 'provider_discount',
	},
})

